/* tslint:disable:indent */
export class Endpoints {

  // diffuseurs
  public static DIFFUSEUR_FINDALL = '/diffuseur/getAll';
  public static DIFFUSEUR_FIND_BOAMP_JOUE = '/diffuseur/getBoampJoue';
  public static DIFFUSEUR_SIRET = '?siret=';
  public static DIFFUSEUR_SERVICE = '&service=';

  // presse specialise
  public static PRESSE = '/diffuseur/presse';

  // formulaire
  public static ALL_CODES = '/formulaire/codes';
  public static ALL_FORMS = '/formulaire/allforms';
  public static FORMULAIRE_PARAM1 = '?orgaID=';
  public static FORMULAIRE_PARAM2 = '&marcheID=';
  public static FORMULAIRE_PARAM3 = '&montantID=';
  public static FORMULAIRE_PARAM4 = '&aviID=';
  public static ALL_CPV = '/formulaire/cpv';
  public static ALL_NUTS = '/formulaire/nuts';
  public static ALL_LANGUAGE = '/formulaire/language';
  public static ALL_COUNTRY = '/formulaire/country';
  public static ALL_CURRENCY = '/formulaire/currency';
  public static ALL_UNITCODE = '/formulaire/unitCode';
  public static ALL_BANDEAU_ERREUR_MAPPING = '/formulaire/bandeauErreurMapping';
  public static FIND_TYPEAVIS = '/formulaire/typeAvisByForm';
  public static TYPEAVIS_PARAM1 = '?form=';

  public static FIND_BY_ORGANISME = '/formulaire/organisme';
  public static FIND_BY_TYPE_MARCHE = '/formulaire/typeMarche';
  public static FIND_BY_MONTANT_MARCHE = '/formulaire/montantMarche';
  public static FIND_BY_TYPE_AVIS = '/formulaire/avisCritere';
  public static FIND = '/formulaire/formCritere';
  public static FIND_BY_FORMNAME = '/formulaire/formByName';

  // AVIS
  public static GET_ONE = '/avis';
  public static GET_ONE_PARAM1 = '?referenceAvis=';
  public static GET_ONE_PARAM2 = '&codeForm=';
  public static GET_ONE_PARAM3 = '&jsonContent=';
  public static GET_ONE_PARAM4 = '&referenceAvisParent=';
  public static GET_ONE_PARAM5 = '&qaNumber=';
  public static IS_EFORM = '&isEform='
  public static PARAM_LANG = '&langue=';

  public static AVIS_FIND_ALL = '/avis/findAll';

  public static AVIS_FIND_BY_REFERENCE = '/avis/getByReference?referenceAvis=';
  public static AVIS_FIND_BY_REFERENCE_LIE = '/avis/getByReferenceLie?referenceAvis=';
  public static AVIS_FIND_BY_REFERENCE_CONNEXE = '/avis/getByReferenceConnexe?referenceAvis=';
  public static AVIS_FIND_SYNTHESE_BY_REFERENCE = '/avis/synthese?referenceAvis=';
  public static AVIS_FIND_HISTORIQUE_BY_REFERENCE = '/avis/historique?referenceAvis=';
  public static AVIS_UPDATE_STATUS = '/avis/updateStatus';
  public static AVIS_CREATE = '/avis';
  public static AVIS_UPDATE = '/avis';
  public static AVIS_DUPLICATE = '/avis/duplicate?reference=';
  public static AVIS_CORRIGER = '/avis/corriger?reference=';
  public static AVIS_CHANGE = '/avis/change?reference=';
  public static AVIS_DELETE = '/avis?reference=';
  public static AVIS_VALIDATE = '/avis/verif';
  public static AVIS_PDF = '/avis/pdfByReference?referenceAvis=';
  public static AVIS_FILTER = '&filter=';
  public static AVIS_STATUT_MSG = '/avis/avisPubMsg';
  public static AVIS_ERREUR_PARSEUR_BY_REFERENCE = '/avis/getErreursParseur?reference=';
  public static FACTU_GET_SIRET = '/facturation/getSiret?code=';
  public static FACTU_GET_TYPE_ENTITE = '/facturation/typeEntite?siret=';
  public static FACTU_GET_IDENTIFIANTS_ADRESSAGE = '/facturation/identifiant-adressage?siret=';
  public static HISTO_REF_CONSULT_AVIS = '/avis/getHistoReferenceConsultation?avisId=';
  // DEV
  public static COMPARE_WITH_VALID = '/dev/compare';
  public static COMPARE_WITH_VALID_PARAM1 = '?formCode=';
  public static COMPARE_WITH_VALID_PARAM2 = '&jsonContent=';

  // ADMINISTRATION
  public static ADMIN_ENDPOINT = '/administration';

  public static ADMIN_SIRET = '?siret=';
  public static ADMIN_SERVICE = '&service=';
  public static ANN_VERIF = '/verif/annonceur?';

  // preference common
  public static PREFERENCE_SIRET = '?siret=';
  public static PREFERENCE_SERVICE = '&service=';
  public static PREFERENCE_ID = '?id=';
  public static PREFERENCE_AND_ID = '&id=';
  public static PREFERENCE_RAISON_SOCIALE = '&raisonSociale='
  // preference partage
  public static PREFERENCE_PARTAGE = '/pref-partage';
  public static PREFERENCE_PARTAGE_RECUP_CODE = Endpoints.PREFERENCE_PARTAGE + '/recup-code';
  public static PREFERENCE_PARTAGE_COPY = Endpoints.PREFERENCE_PARTAGE + '/copy-pref';
  public static PREFERENCE_PARTAGE_CODE = '&code=';
  // preference facturation
  public static PREFERENCE_FACTURATION = '/pref-facturation';
  public static PREFERENCE_FACTURATION_FULL = Endpoints.PREFERENCE_FACTURATION + '/full';
  public static PREFERENCE_FACTURATION_LIGHT = Endpoints.PREFERENCE_FACTURATION + '/light';
  // preference annonceur
  public static PREFERENCE_ANNONCEUR = '/pref-annonceur';
  public static PREFERENCE_ANNONCEUR_FULL = Endpoints.PREFERENCE_ANNONCEUR + '/full';
  public static PREFERENCE_ANNONCEUR_LIGHT = Endpoints.PREFERENCE_ANNONCEUR + '/light';
  // preference cpv
  public static PREFERENCE_CPV = '/pref-cpv';
  public static PREFERENCE_CPV_FULL = Endpoints.PREFERENCE_CPV + '/full';
  public static PREFERENCE_CPV_LIGHT = Endpoints.PREFERENCE_CPV + '/light';
  // preference logo
  public static PREFERENCE_LOGO = '/pref-logo';
  public static PREFERENCE_LOGO_FULL = Endpoints.PREFERENCE_LOGO + '/full';
  public static PREFERENCE_LOGO_LIGHT = Endpoints.PREFERENCE_LOGO + '/light';
  // preference diffuseur
  public static PREFERENCE_DIFFUSEUR = '/pref-diffuseur';
  public static PREFERENCE_DIFFUSEUR_FULL = Endpoints.PREFERENCE_DIFFUSEUR + '/full';
  public static PREFERENCE_DIFFUSEUR_LIGHT = Endpoints.PREFERENCE_DIFFUSEUR + '/light';
  // preference acheteur
  public static PREFERENCE_ACHETEUR = '/pref-acheteur';
  public static PREFERENCE_ACHETEUR_FULL = Endpoints.PREFERENCE_ACHETEUR + '/full';
  public static PREFERENCE_ACHETEUR_LIGHT = Endpoints.PREFERENCE_ACHETEUR + '/light';
  // idWeb
  public static IDWEB = '/idweb';
  public static VERIF_IDWEB = '/verif';

  // habilitation
  public static HABILITATION = '/profiles/user';

  // structure
  public static STRUCTURE = '/facturation/getStructure';

  // avis lies
  public static AVIS_LIES = '&avisLies=';
  public static FIND_LINKABLES = '/formulaire/getLinksByForms?form=';
  public static REFERENCE_AVIS_PARENT = '?referenceAvisParent=';
  public static REFERENCE_AVIS = '/avis/avisref';
  public static REFERENTIEL_EFORM_AVIS_LIES = '/avis/referentielEformAvisLies';
  public static AVIS_ANNULATION_PUBLIES = '/avis/avisAnnulationPublies';
  public static NOTICE_PROCEDURE_ID = '/avis/noticeProcedureId';
  public static AVIS_LIABLES = '/avis/lie/mod2';
  public static AVIS_MOD1_CHECK = '/avis/lie/mod1/check';
  public static MAPPINGAVISLIE = '/avis/mappingAvisLies';

  //Lots
  public static LOT = '/lot';
  public static DUPLICATE = '/duplicate';
  public static AVIS_ID_PARENT = '&avisIdParent=';
  public static IS_PREREMPLISSAGE = '?isPreremplissage=';
  public static LOT_INDEX  = '&lotIndex=';
  public static COUNT = '/count';
  public static CREATE_LOT_AVISLIE = '/create-lot-avislie';

  //Duplicable entity
  public static DUPLICABLE_ENTITY='/duplicable-entity'
  public static AVIS_ID = '?avisId=';
  public static LIST_IDS = '/list-ids';
  public static CREATE_AVISLIE = '/create-avislie';
  public static GET_AVIS = '/get-avis';
  public static INDEX  = '&index=';
  public static TYPE  = '&type=';
  public static ADD_DUPLICABLE_ENTITY = '/add-duplicable-entity'
  public static MODALITE = '&modalite=';

  //Raccordement
  public static REDIRECTION_CONTEXT = '/redirection-contexts';
}
